import { findIndex, pick, whereEq } from 'ramda';
import { SET_LIST, UPDATE_LIST } from '../actions';
import { prepareLeaderBoardList } from './prepareLeaderBoard';

export default (state = {}, action) => {
    switch (action.type) {
        case SET_LIST: {
            const { leaderboards } = action.payload;

            return {
                ...state,
                leaderboards: prepareLeaderBoardList(leaderboards)
            };
        }
        case UPDATE_LIST: {
            const { isHistory, isCustom, leaderboards = [] } = state;
            const update = action.payload;
            const isCompleted = whereEq({ status: 'COMPLETED', joined: true });
            const findIndexForUpdate = findIndex(whereEq(pick(['leaderboardId'], update)));
            const index = findIndexForUpdate(leaderboards);

            if (index > -1) {
                const newList = [...leaderboards];

                newList[index] = {
                    ...newList[index],
                    ...update
                };

                return {
                    ...state,
                    leaderboards: newList
                };

            } else if (!isCustom && (!isHistory || isCompleted(update))) {
                return {
                    ...state,
                    leaderboards: prepareLeaderBoardList([...leaderboards, update])
                };
            }

            return state;
        }
        default:
            return state;
    }
};
